<template>
    <div>
        <tournamentList :game_id="game_id"></tournamentList>
    </div>
</template>

<script>

import tournamentList from '@/components/games/tournament/list.vue';

export default {
    components: {
        tournamentList
    },
    data () {
        let self = (window.x = this)
        return {
            game_id: 6,
        }
    },
    methods: {
    },
    mounted () {
    },
    watch: {},
    computed: {}
}
</script>